export const NAV_PAGES = {
  HOME: 'Home',
  FEEDBACK: 'Feedback',
  VOTE: 'Vote',
};
